import { create } from "zustand"
type ReceivablesState = {
  data: ReceivableMonthType[]
  setData: (data: ReceivableMonthType[]) => void
  clear: () => void
}
const useReceivablesStore = create<ReceivablesState>((set) => ({
  data: [],
  setData: (data) => set({ data }),
  clear: () => set({ data: [] }),
}))
export default useReceivablesStore
